import React, { useEffect, useRef, useState } from 'react';

import ProductVariantsModal from './modal/ProductVariantsModal'

import { getImageUrl, Sizes } from '../components/blocks/editable/Img'

import General from '../utils/General'
import Currency from '../utils/Currency'
import Cart from '../utils/Cart'
import Event from "../utils/Event";
import Navigation from "../utils/Navigation";
import BadgeBlock from './BadgeBlock'

const SWATCH_WIDTH = 37;
const SWATCH_MARGIN = 5;
const TOTAL_SWATCH_WIDTH = SWATCH_WIDTH + SWATCH_MARGIN;

const ProductCardSwatchRow = ({ product, data, setCardSelectedVariant }) => {
  const { display_product_tile_color_swatch, product_tile_color_swatch } = data?.extra || {}
  const campaignProductId = product?.campaignProductId;
  const containerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(0);
  const [selectedVariant, setSelectedVariant] = useState();
  
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        const maxSwatches = Math.floor(width / TOTAL_SWATCH_WIDTH);
        setVisibleCount(Math.max(0, maxSwatches - 1));
      }
    });
    resizeObserver.observe(container);
    return () => resizeObserver.disconnect();
  }, [containerRef?.current]);

  const checkColorVariant = () => {
    const variant = product?.variants?.[0];
    if (variant) {
      for (let i = 1; i <= 3; i++) {
        if (variant?.[`variantName${i}`]?.toLowerCase() === "color") {
          return i
        }
      }
    }
  }

  const getFirstUniqueColorVariant = (variantIndex) => {
    if (!variantIndex) return null;
    const variantObj = {}, variants = [];
    product.variants.forEach((variant) => {
      const variantColorValue = variant[`variantOptionName${variantIndex}`];
      if (variantColorValue && !variantObj[variantColorValue]) {
        variantObj[variantColorValue] = true;
        variants.push(variant);
      }
    });
    return variants;
  }

  const variantIndex = checkColorVariant();

  const variants = getFirstUniqueColorVariant(variantIndex);

  useEffect(() => {
    if (variants?.length && !selectedVariant) {
      setCardSelectedVariant({
        ...variants[0],
        variantIndex: variantIndex
      });
      setSelectedVariant(variants[0]);
    }
  }, [variants?.length, selectedVariant?.variantDetailId])

  return (
    <>
      {
        (display_product_tile_color_swatch && variantIndex && variants?.length) && <div className={`storefront-swatch-container ${visibleCount === 0 ? "m-0" : ""}`} ref={containerRef}>
          {variants.map((item, i) => {
            if ((i + 1) > visibleCount) {
              return null
            }
            return (
              <div
                key={i}
                className="item input-radio input-radio--innerlabel"
                title={item[`variantOptionName${variantIndex}`]}
              >
                <input
                  type="radio"
                  name={`colors${campaignProductId}${data?.block_id}${i}`}
                  value={item.variantDetailId}
                  id={`color${campaignProductId}${data?.block_id}${i}`}
                  checked={selectedVariant?.variantDetailId === item.variantDetailId}
                />
                <label
                  htmlFor={`colors${campaignProductId}${data?.block_id}${i}`}
                  className="m-0 storefront-swatch-label"
                  onClick={(event) => {
                    event.preventDefault();
                    setCardSelectedVariant({
                      ...item,
                      variantIndex: variantIndex
                    });
                    setSelectedVariant(item);
                    const data = JSON.parse(sessionStorage.getItem("ccSelectedProductCardVariant") || "{}");
                    data[`${campaignProductId}.${item.variantDetailId}`] = true;
                    sessionStorage.setItem("ccSelectedProductCardVariant", JSON.stringify(data));
                  }}
                >
                  <div
                    className={`storefront-swatch d-inline-block ${product_tile_color_swatch === "circular" ? "storefront-swatch-radius" : ""}`}
                    style={{
                      backgroundColor: item[`variantOptionName${variantIndex}`]
                    }}
                  >
                  </div>
                </label>
              </div>
            )
          })}
          {
            visibleCount > 0 && variants?.length > visibleCount && <div className="storefront-add-more-swatch">
              <a href={Navigation.getProductUrl(product.campaignProductId)}>
                <div className="storefront-add-more-swatch m-0">+</div>
              </a>
            </div>
          }
        </div>
      }
    </>
  );
}
export default class Product extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      quantity: 1,
      variant: [],
      shop : props.shop,
      product: props.product,
      expandedDesc: {},
      selectedVariant: null
    }

  }

  componentDidMount() {
    this._setup()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps, () => this._setup())
  }

  _setup(){
    General.updateLazyBackgroundImages()
  }

  _renderPrice(product, showColorVariant){
    let price = product.cycle1_price
    const compareAtPrice = product.compareAtPrice

    if(product.on_sale){
      return (
        <>
          <span className="h4 type--strikethrough m-0 pr-1">{ Currency.toFormat(price) }</span>
          <span className="h4 m-0">{ Currency.toFormat(price) }</span>
        </>
      )
    }

    if(product.variants.length > 0){
      if(product.variants[0].price){
        price = product.variants[0].price
      }
    }

    price = showColorVariant && this.state.selectedVariant?.price > 0 ? this.state.selectedVariant?.price : product.cycle1_price

    return <>
      {compareAtPrice > 0 && <span class="h4 type--strikethrough m-0 pr-1">{ Currency.toFormat(compareAtPrice) }</span>}
      <span class="h4 m-0">{ Currency.toFormat(price) }</span>
    </>
  }
  _toggleDesc = (id) => {
    this.setState((prev) => ({
      expandedDesc: {
        ...prev.expandedDesc,
        [id]: !prev.expandedDesc?.[id],
      },
    }));
  };

  render() {
    let {
      product,
      quantity,
      variant,
      showProductVariantsModal
    } = this.state

    if(product == null){
      return (
        <div class="col-md-4">
          <div class="feature feature-1 position-relative">
            <div className="shimmer w-100" style={{height: 290 }}/>
          </div>
        </div>
      )
    }

    let buttonClassName = "col-12"

    let variantOptions = Cart.getOptions(product)
    let customMessageOptions = Cart.getCustomMessageOptions(product)

    let showAddCart = (variantOptions && Object.entries(variantOptions).length < 1) && (customMessageOptions && customMessageOptions.length < 1)

    let cartButtonText = "Add To Cart";
    const checkoutType = window.CURRENT_WEBSITE.checkout_type;
    if(checkoutType === "instant"){
      cartButtonText = "Buy Now"
    }
    const isBoth = (checkoutType === "instantAndCart") || (checkoutType === "instantAndBuy");
    if(showAddCart){
      buttonClassName = "col-6"
    }

    let productClassName = "col-md-4"
    if(window.CURRENT_WEBSITE.extra?.product_page_settings?.column_no === 2){
      productClassName = "col-md-6"
    }else if(window.CURRENT_WEBSITE.extra?.product_page_settings?.column_no === 4){
      productClassName = "col-md-3"
    }
    const showColorVariant = this.props.data?.extra?.display_product_tile_color_swatch && this.state?.selectedVariant?.variantIndex
    const productUrlWithVariant = Navigation.getProductUrl(product.campaignProductId, showColorVariant && this.state.selectedVariant)
    return (
      <div class={`${productClassName} tile-product item`}>
        <div class="feature feature-1 position-relative">
          {
            product.on_sale &&
            <span class="label product-sale-price">Sale</span>
          }
          <a
            class="block"
            priority={this.props.index}
            href={productUrlWithVariant}
            onClick={() => {
              General.setLocationHref(productUrlWithVariant)
            }}
          >
            <span
              class="tile-image block lazy-background lazy-visible"
              style ={{ backgroundImage: "url("+getImageUrl({original: (showColorVariant && this.state.selectedVariant?.imageUrl) || product.imageUrl}, "product")+")" }}
            >
              &nbsp;
            </span>
          </a>
          <div class="feature__body boxed boxed--border pb-0 bt-0 btr-0 storefront-product-card">
            <h5>{ product.productName }{showColorVariant ? ` - ${this.state.selectedVariant[`variantOptionName${this.state?.selectedVariant?.variantIndex}`]}` : ""}</h5>
            {window.CURRENT_WEBSITE.extra?.product_page_settings?.show_description ? (
              <p
                className={`prodDesc ${this.state.expandedDesc[product.campaignProductId] ? 'expanded' : ''}`}
                onClick={() => this._toggleDesc(product.campaignProductId)}
                title="Click to expand"
              >
                {product.productDescription}
              </p>
            ) : null}
            <div class="d-flex align-items-center price"> 
              {this._renderPrice(product, showColorVariant)}
            </div>
            <ProductCardSwatchRow
              product={product}
              data={this.props.data}
              setCardSelectedVariant={(obj) => {
                this.setState({
                  selectedVariant: obj
                })
              }}
            />
            {/* starts, buttons  */}
            <div className="row buttons no-gutters">
              <div className={buttonClassName}>
                {isBoth && showAddCart ? (
                  <a
                    className="btn btn--primary btn-left btn-products px-0 w-100"
                    onClick={() => {
                      window.CURRENT_WEBSITE.checkout_type = "instantAndBuy";
                      this.props.onAddToCartPressed(product, null, [], quantity);
                    }}
                  >
                    <span className="btn__text">Buy Now</span>
                  </a>
                ) : (
                  <a
                    className="btn btn--primary btn-left btn-products px-0"
                    href={productUrlWithVariant}
                    onClick={() => {
                      General.setLocationHref(productUrlWithVariant)
                    }}
                  >
                    <span className="btn__text">More Details</span>
                  </a>
                )}
              </div>
              {showAddCart && (
                <div className="col-6">
                  <a
                    className="btn btn--primary btn-right btn-products px-0 w-100"
                    onClick={() => {
                      if (isBoth) {
                        window.CURRENT_WEBSITE.checkout_type = "instantAndCart";
                      }
                      this.props.onAddToCartPressed(product, null, [], quantity);
                    }}
                  >
                    <span className="btn__text">
                      {isBoth ? "Add To Cart" : cartButtonText}
                    </span>
                  </a>
                </div>
              )}
            </div>
            {/* end, buttons  */}
          </div>
          <BadgeBlock product={product} />
        </div>
      </div>
    )
  }
}
